import Registry from '../../../global/Registry';
import EntityId from '../../../../foundation/domain/EntityId';
import User from '../../users/domain/aggregates/user/User';
import Api from '../../../../foundation/api/Api';
import LessonResult from '../domain/aggregates/lessonResult/LessonResult';
import Lesson from '../domain/aggregates/lesson/Lesson';

export default class LessonResultApi extends Api<LessonResult> {

	private static instance?: LessonResultApi;

	public static getInstance () {
		return this.instance !== undefined ? this.instance : this.instance = new this(Registry.getInstance().lessonResultRepository);
	}

	public async getAllByUserId (userId: EntityId<User>) {
		return this.getList(['/api/lessons-results?userId=', userId]);
	}

	public async markAsCompleted (lessonId: EntityId<Lesson>) {
		return await this.postOne(['/api/lessons/', lessonId, '/mark-as-completed']);
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/api/LessonResultApi.ts